import type { OrderItem, Product } from "@jti/magento";

export const checkIfMixedCart = (items: Product[] | OrderItem[] = []): boolean => {
  const hasSubscription = items.some((item) => item.subscription === 1);
  const hasNonSubscription = items.some((item) => item.subscription !== 1);

  return hasSubscription && hasNonSubscription;
};
